export const parseSuccessEnvelope = async (response) => {
  let payload;
  try {
    payload = await response.json();
  } catch {
    const error = new Error("Unexpected response from API");
    error.status = response?.status;
    error.code = "invalid_response";
    throw error;
  }

  const isObjectPayload = payload && typeof payload === "object" && !Array.isArray(payload);
  const hasErrorEnvelope =
    payload?.success === false || payload?.error || payload?.error_code;

  if (!response.ok || !isObjectPayload || hasErrorEnvelope) {
    const error = new Error(
      payload?.message ||
        payload?.error ||
        (!isObjectPayload ? "Unexpected response from API" : "Request failed"),
    );
    error.errorCode = payload?.error_code;
    error.status = response.status;
    error.code = !isObjectPayload ? "invalid_response" : undefined;
    throw error;
  }

  if (!Object.prototype.hasOwnProperty.call(payload, "data")) {
    const error = new Error("Unexpected response from API");
    error.status = response.status;
    error.code = "invalid_response";
    throw error;
  }

  return payload.data;
};
